import { render, staticRenderFns } from "./SettingsForCamera.vue?vue&type=template&id=7e671534&scoped=true&"
import script from "./SettingsForCamera.vue?vue&type=script&lang=js&"
export * from "./SettingsForCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e671534",
  null
  
)

export default component.exports